import { ButtonV2 } from 'builder/components/Button'
import { Colors } from 'cio-design-library/design-tokens'
import styled, { css } from 'styled-components'

type ButtonContainerRightProps = {
  $isInvisible?: boolean
  $invisibilityStrategy?: 'invisible' | 'none'
}

export const Topbar = styled.div<{ previewWidth?: number }>`
  position: absolute;
  left: 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top: -60px;
  ${({ previewWidth }) =>
    typeof previewWidth === 'number' &&
    previewWidth < 450 &&
    css`
      left: 50%;
      margin-left: -225px;
      width: 450px;
    `};
`

export const ButtonContainerRight = styled.div<ButtonContainerRightProps>(props => {
  const { $isInvisible, $invisibilityStrategy } = props
  return css`
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;

    ${$isInvisible &&
    ($invisibilityStrategy === 'invisible'
      ? css`
          visibility: hidden;
          opacity: 0;
          pointer-events: none;
        `
      : css`
          display: none;
        `)}
  `
})

export const SelectTemplateButtonContainer = styled.div`
  position: relative;
`

export const HighlightAIReviewContainer = styled.div`
  position: absolute;
  top: 80px;
  left: -60%;
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 16px;
  background: white;
  z-index: 300;
  min-width: 400px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
`

export const HighlightAIReviewTitle = styled.span`
  color: ${Colors.Neutral90};

  font-size: 19px;
  font-weight: 500;
  line-height: 24px;
`

export const HighlightAIReviewSubtitle = styled.span`
  color: ${Colors.Neutral50};
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
`

export const HighlightAIReviewCTAButtonContainer = styled(ButtonV2)`
  align-self: flex-end;
  padding: 10px 8px;
  &::before {
    content: '';
    height: 24px;
    width: 24px;
    display: inline-block;
    margin-right: 4px;
    vertical-align: middle;
    background-image: url(${require('images/builder/ai-review-modal/featured.svg')});
  }
`

export const ArrowPointingUp = styled.div`
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 20px;
  background: white;

  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.5);
`
